import React from 'react'
import Information from '../public/Information/Information'
import MenuProvideradmin from './navProvideradmin/MenuProvideradmin'

function RelatedInfoExecutive() {
    return (
        <div>
            <MenuProvideradmin menuActive={'relatedinfo'} />
            <Information type={'executive'}/>
        </div>
    )
}

export default RelatedInfoExecutive